import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import '../styles/holidays.css';
import { Api } from "../api/Api";
import { Empty, Spin } from "antd";
import { showToast } from "../helpers/UIHelper";

const Holidays = () => {
    const [holidays, setHolidays] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        Api.get('/api/MobileHospitalHolidaylist/').then((resp) => {
            if (resp.status === 200 && resp.data.holidaylist.length !== 0) {
                console.log(resp.data.holidaylist);
                setHolidays(resp.data.holidaylist)
            }
        }).catch((e) => {
            showToast('error','Failed to fetch holidays.')
        }).finally(() => {
            setIsLoading(false);
        })
    }, [])
    function convert(dateStr) {
        const [day, month, year] = dateStr.split('/');
        const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        const monthName = monthNames[parseInt(month) - 1];
        return `${monthName} ${parseInt(day)}`;
    }
    const formatDate = (from) => {
        var date = from.split(' ')[0];
        date = date.split('-');
        date = date[2] + '/' + date[1] + '/' + date[0];
        return convert(date);
    }
    return (
        <div className="holidays-page">
            <PageHeader title="Hospital Holidays" />
            {!isLoading ?
                <div className="holiday-list">
                    {holidays.length>0 ? <>
                        {
                            holidays.map((day, index) =>
                                <div className="holiday-item" key={index}>
                                    <div className="occasion">
                                        {day.occasion}
                                    </div>
                                    <div className="date">
                                        {formatDate(day.holiday_date)}
                                    </div>
                                </div>
                            )
                        }
                    </> :
                        <Empty description={false} />
                    }
                </div>
                :
                <div className="loading">
                    <Spin/>
                </div>
            }
        </div>
    )
}
export default Holidays;